import {gql, useMutation} from '@apollo/client';
import {Pda} from './components/Pda';
import {Header} from './components/Header';
import { ArrivalRelatedScanComponent, HandleScanEventResult } from './components/ArrivalRelatedScanComponent';
import { showBarCodeError, showTrackingNumberError } from '../../utils/BarCodeUtil';
import { isTrackingNumber } from '../../utils/BarCodeUtil';
import {NavBar} from "antd-mobile";
import {ArrowLeftOutlined} from "@ant-design/icons";
import React from "react";
import { t } from '../../i18n';
import { getNavBarContainerStyle } from '../../utils/deviceUtils';
import { getClientReporter } from '../../utils/clientReport/clientReporterRegistry';
import { ClientReportOpType } from '../../utils/clientReport/clientReportTypes';
import { safeJsonStringify, truncateToLength } from '../../utils/clientReport/clientReportUtils';


const HANDLE_PICKUP_ARRIVAL_SCAN_EVENT = gql`
   mutation HandleWhsPickupArrivalScanEvent($barCode: String!, $clientReportKey: String) {
     success: handleWhsPickupArrivalScanEvent(barCode: $barCode, clientReportKey: $clientReportKey)
   }
` 

const PageBody = () => {
    const [handlePickupArrivalScanEvent] = useMutation<HandleScanEventResult>(HANDLE_PICKUP_ARRIVAL_SCAN_EVENT);
    const pickupArrivalClientReporter = getClientReporter(ClientReportOpType.PICKUP_ARRIVAL_SCAN);

    const handleScanEvent = async (barCode: string): Promise<HandleScanEventResult> => {
        const clientReportKey = pickupArrivalClientReporter.createReportKey(barCode);
        void pickupArrivalClientReporter.onScanTriggered(clientReportKey, barCode);

        if (!isTrackingNumber(barCode)) {
            showTrackingNumberError(barCode);
            void pickupArrivalClientReporter.onIntercepted(clientReportKey, `invalid_tracking_number:${barCode}`);
            return {success: false};
        }

        void pickupArrivalClientReporter.onRequest(clientReportKey, { barCode });
        let responseRecorded = false;
        let responseData: any = null;
        try {
            const {data} = await handlePickupArrivalScanEvent({ variables: { barCode, clientReportKey } });
            const success = data?.success || false;
            responseData = { success };
            try {
                await pickupArrivalClientReporter.onResponse(clientReportKey, responseData);
                responseRecorded = true;
            } catch (_) {
                // IndexedDB 写入失败，直接触发上报
                void pickupArrivalClientReporter.reportDirectly(clientReportKey, {
                    responseAtMs: Date.now(),
                    responseResult: truncateToLength(safeJsonStringify(responseData), 300)
                });
                responseRecorded = true; // 标记已处理，避免 finally 重复上报
            }
            return {success};
        } catch (e) {
            responseData = { error: String(e) };
            try {
                await pickupArrivalClientReporter.onResponse(clientReportKey, responseData);
                responseRecorded = true;
            } catch (_) {
                // IndexedDB 写入失败，直接触发上报
                void pickupArrivalClientReporter.reportDirectly(clientReportKey, {
                    responseAtMs: Date.now(),
                    responseResult: truncateToLength(safeJsonStringify(responseData), 300)
                });
                responseRecorded = true; // 标记已处理，避免 finally 重复上报
            }
            throw e;
        } finally {
            if (!responseRecorded) {
                try {
                    await pickupArrivalClientReporter.onResponse(clientReportKey, responseData || {});
                } catch (_) {
                    // IndexedDB 写入失败，直接触发上报
                    void pickupArrivalClientReporter.reportDirectly(clientReportKey, {
                        responseAtMs: Date.now(),
                        responseResult: responseData ? truncateToLength(safeJsonStringify(responseData), 300) : ''
                    });
                }
            }
        }
    };
    return (
        <ArrivalRelatedScanComponent
         value1Placeholder={t('pda.pages.pickUpArrival.trackingNO')}
         value1ColumnTitle={t('pda.pages.pickUpArrival.trackingNO')}
         handleScanEvent={handleScanEvent} />
    );
}

export default function PickupArrivalPage() {
    return (
        <div className="w-full h-full flex flex-col gap-2 p-2">
            <div {...getNavBarContainerStyle()}>
                <Header title={t('pda.pages.pickUpArrival.pickUpArrivalScan')}/>
            </div>
            <Pda/>
            <PageBody/>
        </div>
    );
}